import { render, staticRenderFns } from "./AssetsPage.vue?vue&type=template&id=1e9a8dfe&lang=pug&"
import script from "./AssetsPage.vue?vue&type=script&lang=ts&"
export * from "./AssetsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AssetsPage.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
